export const USER_COOKIES_KEY = "uProps";
export const USER_TMP = "uTemps";
